import { doc, updateDoc, collection, getDocs, query, orderBy } from "firebase/firestore"
import { db } from "./config"

export const getAllSupportEmails = async () => {
    try {
        const supportEmailsRef = collection(db, 'support_emails');
        const q = query(supportEmailsRef, orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(q);
        const emails = [];
        querySnapshot.forEach((doc) => {
            emails.push({ id: doc.id, ...doc.data() });
        });
        return emails;
    } catch (error) {
        console.error('Error getting support emails:', error);
        return [];
    }
}

export const updateSupportEmailReplied = async (emailId, replied, reply_content = null, replied_at = null, replier = null) => {
    try {
        const emailRef = doc(db, 'support_emails', emailId);
        const updateData = { replied };
        
        if (reply_content !== null) {
            updateData.reply_content = reply_content;
        }
        
        if (replied_at !== null) {
            updateData.replied_at = replied_at;
        }

        if (replier !== null) {
            updateData.replier = replier;
        }
        
        await updateDoc(emailRef, updateData);
    } catch (error) {
        console.error('Error updating support email:', error);
        throw error;
    }
}